import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hamburgerOpen: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleHamburger: (state) => {
      state.hamburgerOpen = !state.hamburgerOpen;
    },
    openHamburger: (state) => {
      state.hamburgerOpen = true;
    },
    closeHamburger: (state) => {
      state.hamburgerOpen = false;
    },
  },
});

export const {
  toggleHamburger,
  openHamburger,
  closeHamburger,
} = uiSlice.actions;

export default uiSlice.reducer;
